export type SetFunction<T> = (value: (T | ((prevValue: T) => T))) => void;

export const SetFunctionImpl = <T, S extends {},>(
  set: (state: S | ((state: S) => S)) => void,
  field: keyof S,
  value: (T | ((prevValue: T) => T)),
) => typeof value === 'function'
    ? set((s) => ({ ...s, [field]: (value as (prevValue: T) => T)(s[field] as T) }))
    : set((s) => ({ ...s, [field]: value }));